import CompulsionGames from "../../assets/company/CompulsionGames.png";
import SpritesAi from "../../assets/company/SpritesAi.jpg";
import SunnyBrook from "../../assets/company/SunnyBrook.png";
import TTC from "../../assets/company/TTC.png";
import BitGo from "../../assets/company/BitGo.jpg";
import Waterloo from "../../assets/company/UWaterloo.jpeg";

const data = [
  {
    date: "2022, 2023",
    company: "Sunnybrook Focused Ultrasound Lab",
    position: "Software Developer Intern",
    source: SunnyBrook,
  },
  {
    date: "2024",
    company: "Compulsion Games (Xbox)",
    position: "Engine/Tools Programmer",
    source: CompulsionGames,
  },
  {
    date: "2024",
    company: "Sprites Ai (Y Combinator)",
    position: "Software Engineer Intern",
    source: SpritesAi,
  },
  {
    date: "2025",
    company: "Toronto Transit Comission",
    position: "Software Engineer Intern",
    source: TTC,
  },
  {
    date: "2026",
    company: "University of Waterloo",
    position: "Computer Graphics Research Assistant",
    source: Waterloo,
  },
  {
    date: "2026",
    company: "BitGo",
    position: "Software Engineer Intern",
    source: BitGo,
  },
];

export default data;
